

export default class{

    constructor( options ) {
        this.defaults = {
        	$el   : false,
        	main  : null,

       };

        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'escr-form';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;
        this.$win           =   $(window);
		
        this.init();
    }

    init(){
    	//this.addEvents( true );


        this.setHiddenFields();
	}

    setHiddenFields(){
        // set title
        this.$el.find( 'input[name="post_title"]' ).val( $( 'h1.hero-title' ).text() );
        // set current url
        this.$el.find( 'input[name="post_url"]' ).val( document.location.href );
    }


    /*
    addEvents( b ){
       this.debounceResize(b);
    }

    debounceResize(b){
        if ( b ){
            // debounce resize
            this._debResize = _debounce( () => this.onResize(), 117 );
            this.$win.on( 'resize', this._debResize );
            this.onResize();
        }
        else{
            if ( this._debResize ){
                this._debResize.cancel();
                this.$win.off( 'resize', this._debResize );
            }        
        }
    }

    onResize(){

    }

    */

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
        //this.addEvents( false );
    }

}